import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]
  static values = { min: { type: Number, default: 1 } }

  add(event) {
    event.preventDefault()
    if (!this.hasTemplateTarget) return

    const clone = this.templateTarget.cloneNode(true)
    clone.querySelectorAll("input, select, textarea").forEach(el => { el.value = "" })
    clone.removeAttribute("data-dynamic-list-target")
    clone.classList.remove("hidden")
    this.containerTarget.appendChild(clone)
  }

  remove(event) {
    event.preventDefault()
    const item = event.currentTarget.closest("[data-list-item]")
    if (!item) return

    const items = this.containerTarget.querySelectorAll("[data-list-item]")
    if (items.length <= this.minValue) return

    item.remove()
  }
}
